export class StringPairFilter {

  constructor() {
  }

  init(params) {
    this.valueGetter = params.valueGetter
    this.filterText = null
    this.setupGui(params)
  }

  setupGui(params) {
    this.gui = document.createElement('div')
    this.gui.innerHTML =
        '<div style="padding: 4px; width: 200px;">' +
        '<div style="font-weight: bold;">Filter</div>' +
        '<div><input style="margin: 4px 0 4px 0;" id="filterText"/></div>' +
        '</div>'

    this.eFilterText = this.gui.querySelector('#filterText')

    const listener = (event) => {
      this.filterText = event.target.value
      params.filterChangedCallback()
    }

    this.eFilterText.addEventListener("changed", listener)
    this.eFilterText.addEventListener("paste", listener)
    this.eFilterText.addEventListener("input", listener)
    // IE doesn't fire changed for special keys (eg delete, backspace), so need to
    // listen for this further ones
    this.eFilterText.addEventListener("keydown", listener)
    this.eFilterText.addEventListener("keyup", listener)
  }

  getGui() {
    return this.gui
  }

  doesFilterPass(params) {
    // make sure each word passes separately, ie search for first, second
    let passed = false
    const valueGetter = this.valueGetter
    this.filterText.toLowerCase().split(" ").forEach((filterWord) => {
      const pair = valueGetter(params)
      if (!pair) {
        return
      }
      const first = pair.first || pair.props && pair.props.first
      const second = pair.second || pair.props && pair.props.second
      if (first && (first.toString().toLowerCase().indexOf(filterWord) >= 0) ||
          second && (second.toString().toLowerCase().indexOf(filterWord) >= 0)) {
        passed = true
      }
    })
    return passed
  }

  isFilterActive() {
    return !!this.filterText
  }

  getModel() {
    return {value: this.filterText}
  }

  setModel(model) {
    if (model && typeof model === 'object') {
      this.eFilterText.value = model.value
      this.filterText = model.value
      return
    }

    this.eFilterText.value = model
    this.filterText = model
  }

}